var map = {
	"./2019/toc.json": 82023,
	"./2022-BoB/toc.json": 59451,
	"./2022-Build/toc.json": 46236,
	"./2022-District/toc.json": 48132,
	"./2022-Offseason/toc.json": 28296,
	"./2022-Qualifiers/toc.json": 44655,
	"./2023-Alexandria/toc.json": 81412,
	"./2023-Offseason/toc.json": 3799,
	"./2024-Build/toc.json": 138,
	"./2024-Competition/toc.json": 32365,
	"./2025-Magic-of-Science/toc.json": 33117,
	"./2025-Pasadena/toc.json": 88,
	"./2026-Competition/toc.json": 25511,
	"./2026-Kickoff/toc.json": 66027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77898;